import { render, staticRenderFns } from "./WaiverMarketing.vue?vue&type=template&id=5bd822b3&scoped=true&"
import script from "./WaiverMarketing.vue?vue&type=script&lang=js&"
export * from "./WaiverMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd822b3",
  null
  
)

export default component.exports